import React, { useEffect, useState } from 'react';
import img from '../assets/nav-logo.webp';

const Navbar1 = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <div className="topNav">
                <a href="javascript:void(0)" className="landing-slider-button">10-Day Free Trial – Get Started</a>
            </div>
            <nav className={`navbar navbar-expand-lg bg-body-tertiary ${scrolled ? 'navbar-scrolled' : ''}`}>
                <div className="container">
                    <a className="navbar-brand" href="#">
                        <img src={img} alt="Navbar Logo" />
                    </a>
                </div>
            </nav>
        </>
    );
};

export default Navbar1;